import { type Point, point } from '@ipfabric/utils';
import { array } from 'fp-ts';
import type { Graphics } from 'pixi.js';

export const drawDottedLine = (
  edgeLine: Graphics,
  start: Point,
  end: Point,
  thickness: number,
  color: number,
): void => {
  if (thickness === undefined) {
    return;
  }
  const breakPointLength = thickness * 2;
  const xLength = end.x - start.x;
  const yLength = end.y - start.y;
  const lineLength = Math.sqrt(xLength ** 2 + yLength ** 2);
  const xScale = xLength / lineLength;
  const yScale = yLength / lineLength;
  const dotsCount = Math.ceil(lineLength / breakPointLength);
  const offsetX = (thickness / 2) * xScale;
  const offsetY = (thickness / 2) * yScale;
  const breakPointXLength = (xLength - offsetX) / dotsCount;
  const breakPointYLength = (yLength - offsetY) / dotsCount;
  const breakpoints = array.makeBy(dotsCount, (index) =>
    point.create(
      start.x + (index + 1) * breakPointXLength - offsetX,
      start.y + (index + 1) * breakPointYLength - offsetY,
    ),
  );

  for (const breakpoint of breakpoints) {
    edgeLine.beginFill(color);
    edgeLine.lineStyle(0);
    edgeLine.drawCircle(breakpoint.x, breakpoint.y, thickness / 2);
    edgeLine.endFill();
  }
};
